module.exports = __webpack_public_path__ + "images/walletIcon-72f4b5.svg";